import styled from 'styled-components';

// internal
import { SCREEN_SIZE } from '@app/assets/styles/const';
import { Modal } from 'antd';
import { flex } from '../../assets/styles/mixins';

interface IProps {
  fontSize?: 1 | 2;
  editWidth?: number;
}

export const CustomModal = styled(Modal)<IProps>`
  .ant-modal-body {
    height: 100%;
    width: ${(props) => (props.editWidth ? `${props.editWidth}px` : '100%')};
    padding: 40px;
  }
  .ant-modal-content {
    border-radius: 10px !important;
    width: ${(props) => (props.editWidth ? `${props.editWidth}px` : '100%')};
  }

  .image-container {
    width: 100px;
    height: 100px;
    svg {
      height: 100%;
      width: 100%;
      padding-bottom: 30px;
    }
  }

  .title {
    padding-bottom: 10px;
    margin-bottom: 10px;
    font-family: 'Roboto-Medium';
    font-size: ${(props) =>
      (props.fontSize === 1 && '22px') || (props.fontSize === 2 && '20px') || '16px'};
  }

  .description {
    font-size: 14px;
    color: ${(props) => props.theme.steel};
  }

  .action {
    padding-top: 30px;
    ${flex('center', 'center')}
    .ant-btn {
      width: 145px;
      font-size: 16px !important;
      color: ${(props) => props.theme.darkblue};
      background: ${(props) => props.theme.ggBackground};
    }
    .start {
      margin-right: 30px;
      .ant-btn {
        color: ${(props) => props.theme.white};
        background: ${(props) => props.theme.darkblue};
      }
    }
  }

  .ant-modal-body > .hidden {
    padding-top: 0px;
  }

  .button-container {
    width: 160px;
    height: 42px;

    Button {
      width: 100%;
    }

    .primary-btn {
      color: ${(props) => props.theme.white};
      background: ${(props) => props.theme.darkblue} !important;
    }
  }

  @media screen and (max-width: ${SCREEN_SIZE.md}) {
    .action {
      .ant-btn {
        width: 30vw;
      }

      .start {
        margin-right: 10px;
      }
    }
  }
`;
